(function () {
  Motion.file('inspector/title.js', function (require) {
    Motion.staticStyles('Inspector.Title', {
      '$title': '#_motiondevtools title.Inspector-Title, #_motiondevtools .Inspector-Title.title, #_motiondevtools .ViewInspector-Title.title, #_motiondevtools .Inspector-Title > .title',
      '$closed': '#_motiondevtools closed.Inspector-Title, #_motiondevtools .Inspector-Title.closed, #_motiondevtools .ViewInspector-Title.closed, #_motiondevtools .Inspector-Title > .closed',
      '$inner': '#_motiondevtools inner.Inspector-Title, #_motiondevtools .Inspector-Title.inner, #_motiondevtools .ViewInspector-Title.inner, #_motiondevtools .Inspector-Title > .inner'
    }, {
      '$title': {
        fontWeight: 300,
        fontSize: 11,
        borderBottom: '1px solid #f4f4f4',
        height: 10,
        margin: [0, 5, 4],
        color: 'rgba(0,0,0,0.4)',
        flexFlow: 'row'
      },
      '$closed': {
        marginTop: 1
      },
      '$inner': {
        padding: [4, 10],
        background: '#fff'
      }
    });
    Motion.view('Inspector.Title', function (view, on, $) {
      var open = true;

      function toggle() {
        if (!view.props.onToggle) return;
        view.set('open', open = !open);
        view.props.onToggle(open);
        view.updateSoft();
      }

      ;view.render(function () {
        return view.el(
          ['title', 1],
          { onClick: toggle },
          view.el(
            ['inner', 1],
            null,
            view.props.children
          )
        );
      });

      $["closed"] = function (_, _index) {
        return {
          transform: { scale: 0.8 } };
      };

      $["inner"] = function (_, _index) {
        return { margin: [-2, 'auto']
        };
      };
    });
  })
})();
//# sourceMappingURL=title.js.map
